import { Middleware } from '@reduxjs/toolkit';
import * as Sentry from '@sentry/react';

/**
 * Redux middleware that adds Sentry breadcrumbs for dispatched actions
 * Helps track what actions led to an error
 */
export const sentryReduxMiddleware: Middleware = () => (next) => (action) => {
    // Only add breadcrumbs in production
    if (process.env.NODE_ENV === 'development') {
        return next(action);
    }

    const actionType = (action as { type?: string }).type;

    // Skip adding breadcrumbs for certain action types
    if (actionType) {
        // Don't track internal RTK Query actions or auth token updates (security)
        const skipPatterns = [
            '/executeQuery/pending',
            '/executeQuery/fulfilled',
            'setTokens',
            'setCustomerTokens',
        ];

        const shouldSkip = skipPatterns.some(pattern => actionType.includes(pattern));

        if (!shouldSkip) {
            Sentry.addBreadcrumb({
                category: 'redux',
                message: actionType,
                level: 'info',
                data: {
                    // Only include non-sensitive payload info
                    type: actionType,
                    // Don't include full payload to avoid sensitive data
                },
            });
        }
    }

    return next(action);
};
